import { TicketingTax } from "@/features/LiveFormEditor/Steps/StepTickets/hooks/useTicketingTaxes";

const RATE_PPM_PER_PERCENT = 10_000;

export const sumTaxRatePpm = (taxIds: string[] | undefined, taxRatePpmById: ReadonlyMap<string, number>): number =>
  (taxIds ?? []).reduce((sum, taxId) => sum + (taxRatePpmById.get(taxId) ?? 0), 0);

export const formatRatePpmAsPercent = (ratePpm: number, locale: string): string =>
  new Intl.NumberFormat(locale, { maximumFractionDigits: 4 }).format(ratePpm / RATE_PPM_PER_PERCENT);

export const getRestorableTaxIds = (stashedIds: string[], taxes: TicketingTax[]): string[] => {
  const activeIds = new Set(taxes.map((tax) => tax.id));
  return stashedIds.filter((id) => activeIds.has(id));
};
